// extracted by mini-css-extract-plugin
module.exports = {"header":"NotFound_header__9cxvZ","logo":"NotFound_logo__hHsmW","container":"NotFound_container__fYVCG","title":"NotFound_title__qcQyX","subtitle":"NotFound_subtitle__HYjJR"};